import _ from 'lodash'
import React, { Component } from 'react'
import { Header, Label, Button, Icon, Form } from 'semantic-ui-react'
import SimpleEntryTable from './SimpleEntryTable'
import Help from './Help'
import GoogleAnalytics from 'react-ga'

class DesktopSync extends Component {
  state = { 
    remoteData:[],
    numberOfEntries:0,
    sumOfEntries:0,
    gotData:false,
    logText:""
  }
  fileInputRef = React.createRef();

fileChange = e => {

  const file = e.target.files[0];
  if (!file) {
      return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
      const text = JSON.parse(e.target.result);
      // Process the file content here
      console.log(text);
      this.setState({remoteData:text.entries},()=>this.calcValues());
  };
  reader.readAsText(file); // Read the file as text

};
  calcValues(){
    const entries = this.state.remoteData;
    
    const num = entries.length;
    const sum=_.reduce(entries, function(sum, n) {
      return sum + n.value;
    }, 0);
    this.setState({numberOfEntries:num, sumOfEntries:sum});
    if(num>0)
      this.setState({gotData:true})
    GoogleAnalytics.event({category: 'Sync', action: 'Recieved' });
  }

   pushLocally=()=>{
    this.log("Start pushing");
    //const remoteData = JSON.stringify(this.state.remoteData);
    const remoteData = {entries:this.state.remoteData};

    try {
      //localhost debugging: checknetisolation LoopbackExempt -a -n=Microsoft.Win32WebViewHost_cw5n1h2txyewy
      if (typeof (window.external) !== 'undefined' && ('notify' in window.external)) {
        window.external.notify(remoteData); //legacy korAccount
      }
      else{
        window.chrome.webview.postMessage(remoteData);
      }
      GoogleAnalytics.event({category: 'Sync', action: 'Imported' });
    } catch (err) {
      this.log(err);
      alert(err);
      GoogleAnalytics.exception({description: 'Sync Error Import'+err, fatal: false })
      GoogleAnalytics.event({category: 'Sync', action: 'Import failed' });
    }
  }
  log(value)
  {
     this.setState({logText:value})
  }
  render() {
    return (
      <div>
        <Header>Wählen Sie die Datei die Sie aus korAccount Mobile auf Ihrem Mobilgerät heruntergeladen haben.</Header>
       
        <Form onSubmit={this.onFormSubmit}>
              <Form.Field>
                <Button 
                  content="Datei wählen"
                  labelPosition="left"
                  icon="file"
                  onClick={() => this.fileInputRef.current.click()}
                />
                <input
                  ref={this.fileInputRef}
                  type="file"
                  hidden
                  accept=".kaim"
                  onChange={this.fileChange}
                />
              </Form.Field>
            </Form>
            <br />

        {this.state.gotData && 
        <div><br /> 
        <Button primary onClick={this.pushLocally}><Icon name='download' />{this.state.numberOfEntries} Einträge importieren</Button>
        </div>
        }
        <br />
        <SimpleEntryTable data={JSON.stringify(this.state.remoteData)} numberOfEntries={this.state.numberOfEntries} sumOfEntries={this.state.sumOfEntries} />
        <br />
        <Help IsDesktop={true} />
        <div>{this.state.logText}</div>
        <div>{JSON.stringify(this.state.remoteData)}</div>
      </div>
    )
  }
}

export default DesktopSync;